import bash from 'highlight.js/lib/languages/bash';
import css from 'highlight.js/lib/languages/css';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import typescript from 'highlight.js/lib/languages/typescript';
import sql from 'highlight.js/lib/languages/sql';
import yaml from 'highlight.js/lib/languages/yaml';
import xml from 'highlight.js/lib/languages/xml';

export default [
    {
        name: "bash",
        definition: bash
    },
    {
        name: "css",
        definition: css
    },
    {
        name: "java",
        definition: java
    },
    {
        name: "javascript",
        definition: javascript
    },
    {
        name: "python",
        definition: python
    },
    {
        name: "typescript",
        definition: typescript
    },
    {
        name: "sql",
        definition: sql
    },
    {
        name: "yaml",
        definition: yaml
    },
    {
        name: "xml",
        definition: xml
    }
]